import React from 'react';

import {ThemeProvider, StyledEngineProvider} from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

export const WrapThemeProvider = (theme) => ({children}) => {
	return (
		<React.Fragment>
			<StyledEngineProvider injectFirst>
				<ThemeProvider theme={theme}>
					<CssBaseline />

					{children}
				</ThemeProvider>
			</StyledEngineProvider>
		</React.Fragment>
	);
};

export default WrapThemeProvider;
